import { Component, input, OnDestroy, OnInit, output } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal-service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {
  readonly paddingModal = input<string>('24px');
  readonly background = input<string>('white');
  readonly headerBackground = input<string>('white');
  readonly headerColor = input<string>();
  readonly width = input<string>('37.5rem');
  readonly height = input<string>();
  readonly title = input<string>();
  readonly link = input<string>();
  readonly paddingHeader = input<string>('1.5rem');
  readonly paddingContent = input<string>('1.5rem');
  readonly type = input<string>();
  readonly iconBack = input<boolean>();
  readonly searchResult = input<{ text: string; color: string; } | null>(null);
  readonly haveFooter = input<boolean>(false);
  readonly overflow = input<string>();
  readonly gap = input<string>();
  readonly linkClick = output<void>();
  readonly backClick = output<void>();

  constructor(public modalService: ModalService){}

  ngOnInit(){}

  public dialogClose() {
    this.modalService.closeModal(this.type());
  }

  public ngOnDestroy() {
    this.modalService.closeModal(this.type());
  }

  public closeModal(event: Event) {
    if (event.target === event.currentTarget) {
      this.dialogClose();
    }
  }

  public linkClicked(){
    this.linkClick.emit();
  }

  public backClicked(){
    this.backClick.emit();
  }

}
